/** @format */

import React, {createContext} from 'react';

const activeOrdersDefaultState = {
    loading: true,
    carts: []
};

const activeOrdersDefaultContext = {
    state: activeOrdersDefaultState,
    handleUpdateProof: () => {}
};

const ActiveOrdersContext = createContext(activeOrdersDefaultContext);
export {activeOrdersDefaultState, ActiveOrdersContext};
